import { useNavigate } from "react-router-dom"

export const Service = () => {

    const navigate = useNavigate()
    return (
        <>
            <div className="row px-lg-5 pb-lg-5 align-items-center bg_color3" >

                <div className="col-12 pb-3 pb-lg-5">
                    <h3 className="fw-bold text-center green pt-3">SERVICES</h3>
                    <div className="col-8 col-lg-2 mx-auto  zoom-in-out-box2 text-center">
                        <hr />
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4 py-3 py-lg-0 ">
                    <div className="border_specialist mx-2 m-lg-3 cursor_pointer" onClick={()=> navigate ('/LearningAndDevelopment?Section=Contents on Board')}>
                        {/* <img src="Static/Assets/Img/student-01.jpg" className=" busimess2"> */}
                        <img src="Static/Assets/Img/services/Contents on Board.jpg" className="busimess2 " alt="" />
                        <h5 className="Specialised_para py-3 fs-7 text-center">Contents on Board</h5>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4 py-3 py-lg-0 ">
                    <div className="border_specialist mx-2 m-lg-3 cursor_pointer" onClick={()=> navigate ('/LearningAndDevelopment?Section=Professional Development')}>
                        {/* <img src="Static/Assets/Img/student-01.jpg" className=" busimess2"> */}
                        <img src="Static/Assets/Img/services/Professional Development.jpg" className="busimess2 " alt="" />
                        <h5 className="Specialised_para p-3 fs-7 text-center">Professional Development</h5>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4 py-3 py-lg-0 ">
                    <div className="border_specialist mx-2 m-lg-3 cursor_pointer" onClick={()=> navigate ('/Consultancy')}>
                        {/* <img src="Static/Assets/Img/student-01.jpg" className=" busimess2"> */}
                        <img src="Static/Assets/Img/services/Claim Consultancy.jpg" className="busimess2 " alt="" />
                        <h5 className="Specialised_para py-3 fs-7 text-center"> Claim Consultancy </h5>
                    </div>
                </div>

            </div>
        </>
    )
}
